import {
  BaseQueryFn,
  EndpointBuilder,
  QueryDefinition,
} from '@reduxjs/toolkit/query';

import type { ICollectionApiResponse } from 'services/api/api.types';
import type { ISkill } from 'interfaces/Skill.interface';
import type {
  IGetSkillItemArgs,
  ISkillCollectionResponse,
  ISkillsCollectionArgs,
} from './skills.api.types';
import {
  serializeFilters,
  serializeFlatObject,
} from 'services/helper/getPaginationParams.helper';
import { transformCollectionResponse } from 'services/teamHeroApi.helpers';

export const getSkills = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<
  ISkillsCollectionArgs,
  BaseQueryFn,
  string,
  ISkillCollectionResponse
> =>
  build.query<ISkillCollectionResponse, ISkillsCollectionArgs>({
    providesTags: ['Skill'],
    query: (queryArg: ISkillsCollectionArgs) => {
      const paginationParamObject = {
        page: queryArg.page,
        itemsPerPage: queryArg.itemsPerPage,
        pagination: queryArg.pagination,
        ...queryArg.order,
      };
      const paginationQuery = serializeFlatObject(paginationParamObject, '?');
      const filterQuery = serializeFilters(queryArg.filters);

      return {
        url: `api/skills${paginationQuery}${filterQuery}`,
      };
    },
    transformResponse: (
      response: ICollectionApiResponse<ISkill>
    ): ISkillCollectionResponse =>
      transformCollectionResponse<ISkill>(response),
  });

export const getSkillItem = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<IGetSkillItemArgs, BaseQueryFn, string, ISkill> =>
  build.query<ISkill, IGetSkillItemArgs>({
    providesTags: ['Holiday'],
    query: (queryArg: IGetSkillItemArgs) => ({
      url: `api/skills/${queryArg.id}`,
    }),
  });
